import React from "react";
import {
    FiTarget,
    FiEye,
    FiGlobe,
    FiUsers,
    FiAward,
    FiPackage,
    FiCheckCircle,
    FiHeart,
    FiShield,
    FiTrendingUp,
} from "react-icons/fi";

const AboutUs = () => {
    return (
        <>
            {/* Hero Section */}
            <div
                className="py-5 text-white"
                style={{
                    background: "linear-gradient(135deg, #1a4d2e, #20c997)",
                }}
            >
                <div className="container py-5 text-center">
                    <h1 className="display-4 fw-bold mb-3">About Us</h1>
                    <p className="fs-5 opacity-75 mb-0">
                        Leading exporter of premium Indian fruits since 2010
                    </p>
                </div>
            </div>

            {/* Story Section */}
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <span
                            className="badge mb-3"
                            style={{
                                backgroundColor: "var(--color-bg)",
                                color: "var(--color-primary)",
                                padding: "8px 16px",
                                borderRadius: "30px",
                            }}
                        >
                            Our Story
                        </span>

                        <h2 className="fw-bold mb-4">
                            Bringing India's Finest Fruits to the World
                        </h2>

                        <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
                            Founded in 2010, we have grown from a small family business into a
                            trusted global export partner delivering premium Indian fruits to
                            more than 15 countries.
                        </p>

                        <p className="text-muted" style={{ lineHeight: "1.8" }}>
                            We work closely with farming communities to ensure sustainable
                            practices, fair trade, and consistent export-grade quality.
                        </p>
                    </div>

                    <div className="col-lg-6">
                        <div
                            className="p-5 rounded-4 shadow text-center"
                            style={{ backgroundColor: "var(--color-bg)" }}
                        >
                            <FiGlobe size={80} className="text-success mb-3" />
                            <h4 className="fw-bold">Global Export Network</h4>
                            <p className="text-muted mb-0">
                                Delivering fresh fruits from Indian farms to international
                                markets.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="container">
                <div className="row g-4 text-center">
                    {[
                        { icon: <FiGlobe size={32} />, number: "15+", label: "Countries" },
                        { icon: <FiUsers size={32} />, number: "50+", label: "Farm Partners" },
                        { icon: <FiAward size={32} />, number: "100+", label: "Happy Clients" },
                        { icon: <FiTrendingUp size={32} />, number: "15+", label: "Years Experience" },
                    ].map((item, index) => (
                        <div className="col-md-3 col-6" key={index}>
                            <div
                                className="card border-0 shadow-sm h-100"
                                style={{ borderRadius: "18px" }}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-center justify-content-center">

                                    {/* Icon Circle */}
                                    <div
                                        className="d-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "50%",
                                            backgroundColor: "rgba(25,135,84,0.1)",
                                            color: "#198754",
                                        }}
                                    >
                                        {item.icon}
                                    </div>

                                    {/* Number */}
                                    <h2 className="fw-bold text-success mb-2">
                                        {item.number}
                                    </h2>

                                    {/* Label */}
                                    <p className="fw-semibold mb-0 text-muted">
                                        {item.label}
                                    </p>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            {/* Mission & Vision */}
            <div className="container py-5">
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="card border-0 shadow h-100 rounded-4">
                            <div className="card-body p-5">
                                <FiTarget size={40} className="text-success mb-3" />
                                <h3 className="fw-bold mb-3">Our Mission</h3>
                                <p className="text-muted mb-0">
                                    To deliver premium quality fruits globally while empowering
                                    farmers and promoting sustainable agriculture.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card border-0 shadow h-100 rounded-4">
                            <div className="card-body p-5">
                                <FiEye size={40} className="text-success mb-3" />
                                <h3 className="fw-bold mb-3">Our Vision</h3>
                                <p className="text-muted mb-0">
                                    To become the most trusted fruit export company connecting
                                    Indian farms to global markets.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Values Section */}
            <div className="py-5" style={{ backgroundColor: "var(--color-bg)" }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Our Core Values</h2>
                        <p className="text-muted">
                            Principles that guide our export excellence
                        </p>
                    </div>

                    <div className="row g-4">
                        {[
                            { icon: <FiCheckCircle />, title: "Quality First" },
                            { icon: <FiUsers />, title: "Fair Trade" },
                            { icon: <FiHeart />, title: "Sustainability" },
                            { icon: <FiPackage />, title: "Reliable Delivery" },
                            { icon: <FiShield />, title: "Certified Standards" },
                            { icon: <FiGlobe />, title: "Global Reach" },
                        ].map((value, index) => (
                            <div className="col-md-4 col-6" key={index}>
                                <div className="card border-0 shadow-sm text-center h-100 rounded-4">
                                    <div className="card-body p-4">
                                        <div className="text-success mb-3">{value.icon}</div>
                                        <h6 className="fw-bold">{value.title}</h6>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div
                className="py-5 text-center text-white"
                style={{
                    background: "linear-gradient(135deg, #1a4d2e, #20c997)",
                }}
            >
                <div className="container">
                    <h2 className="fw-bold mb-3">Partner With Us</h2>
                    <p className="opacity-75 mb-4">
                        Experience premium Indian fruits delivered worldwide.
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <button className="btn btn-light btn-lg px-5 py-3 fw-semibold rounded-3">
                            Become a Partner
                        </button>

                        <button className="btn btn-outline-light btn-lg px-5 py-3 fw-semibold rounded-3">
                            Contact Sales
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutUs;
